import { BookingApiError, parseCredentials, parseReservationPayload } from './api';
import { ReservationAttempt, ReservationCredentials } from './model';

export const RESERVATION_SESSION_KEY = 'quadtrip.reservation.v1';
export interface ReservationSession {
  savedAt: number;
  attempt?: ReservationAttempt;
  credentials?: ReservationCredentials;
  unresolved?: boolean;
}

export function saveReservationSession(storage: Storage, session: ReservationSession) {
  try { storage.setItem(RESERVATION_SESSION_KEY, JSON.stringify(session)); }
  catch { throw new BookingApiError('STORAGE_UNAVAILABLE'); }
}

export function clearReservationSession(storage: Storage) {
  try { storage.removeItem(RESERVATION_SESSION_KEY); }
  catch { throw new BookingApiError('STORAGE_UNAVAILABLE'); }
}

export function readReservationSession(storage: Storage, now = Date.now()): ReservationSession | null {
  let raw: string | null;
  try { raw = storage.getItem(RESERVATION_SESSION_KEY); }
  catch { throw new BookingApiError('STORAGE_UNAVAILABLE'); }
  if (!raw) return null;
  let data: unknown;
  try { data = JSON.parse(raw); } catch { throw new BookingApiError('INVALID_SAVED_SESSION'); }
  if (!data || typeof data !== 'object' || !('savedAt' in data)
    || typeof data.savedAt !== 'number' || !Number.isFinite(data.savedAt)) {
    throw new BookingApiError('INVALID_SAVED_SESSION');
  }
  const session: ReservationSession = { savedAt: data.savedAt };
  if ('credentials' in data && data.credentials !== undefined) session.credentials = parseCredentials(data.credentials);
  if ('attempt' in data && data.attempt !== undefined) {
    const attempt = data.attempt;
    if (!attempt || typeof attempt !== 'object' || !('key' in attempt) || typeof attempt.key !== 'string'
      || !/^[a-f0-9-]{36}$/i.test(attempt.key) || !('createdAt' in attempt) || typeof attempt.createdAt !== 'number'
      || !Number.isFinite(attempt.createdAt) || !('payload' in attempt)) throw new BookingApiError('INVALID_SAVED_SESSION');
    session.attempt = { key: attempt.key, createdAt: attempt.createdAt, payload: parseReservationPayload(attempt.payload) };
    if (now - session.attempt.createdAt > 60 * 60_000) {
      session.attempt = undefined;
      session.unresolved = !session.credentials;
    }
  }
  if ('unresolved' in data && data.unresolved === true) session.unresolved = true;
  if (now - session.savedAt > 24 * 60 * 60_000) {
    session.attempt = undefined; session.credentials = undefined; session.unresolved = true;
  }
  saveReservationSession(storage, session);
  return session;
}
